export default __webpack_public_path__ + "static/media/downArrow.0cbc24ab.svg";